import styled from 'styled-components';
import Button from '@@Components/Buttons/Button';
export const InformationImageContainer = styled.div `
  width: 100vw;
  display: flex;
  height: 92.5vh;
  @media (max-width: 1000px) { height: 97.5vh; }
  ${props => props.theme.mixins.mobile(`
    flex-direction: column-reverse;
    height: 100%;
  `)}
`;
export const TextColumn = styled.div `
  ${props => props.src && `
    background-image: url(${props.src});
  `}
  width: 50vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${props => props.theme.mixins.mobile(`
    width: 100vw;
    padding: 25px 15px;
  `)}
`;
export const ImageColumn = styled.div `
  width: 50vw;
  height: 100%;
  ${props => props.theme.mixins.mobile(`
    width: 100vw;
  `)}
`;
export const TextWrapper = styled.div `
  width: 530px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  @media (max-width: 1200px) {
    width: 43vw;
  }
  ${props => props.theme.mixins.mobile('width: 100%;')}
`;
export const Heading = styled.p `
  font-size: 16px;
  margin-bottom: 10px;
  font-weight: 600;
  ${props => props.theme.mixins.mobile('font-size: 14px;')}
`;
export const Title = styled.h2 ``;
export const Description = styled.div `
  font-size: 16px;
  line-height: 26px;
  margin: 30px 0 35px 0;
  ${props => props.theme.mixins.mobile(`
    font-size: 14px;
    margin: 25px 0;
  `)}
`;
export const DownloadButtonWrapper = styled.div `
  display: flex;
`;
export const DownloadButton = styled.button `
  display: flex;
`;
export const ButtonContent = styled.div `
  font-size: 14px;
  font-weight: 600;
  padding-left: 15px;
`;
export const AdditionalButton = styled(Button) `
  width: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 25px;
  ${props => props.theme.mixins.mobile('margin-top: 30px;')}
`;
export const Image = styled.img `
  object-fit: cover;
  width: 100%;
  height: 100%;
`;
export const SecondContainer = styled.div `
  pointer-events: ${props => props.shown ? 'all' : 'none'};
  opacity: ${props => props.shown ? 1 : 0};
  transition: opacity .6s ease;
  width: 100%;
  height: 100%;

  display: flex;
  ${props => props.theme.mixins.mobile('padding-top: 100px;')}

  align-items: center;
  justify-content: center;
  /* The gradient is covering the image to darken it */
  ${props => props.backgroundSrc && `
    background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${props.backgroundSrc});
    background-size: cover;
  `}
`;
export const SecondTextWrapper = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 30% 15px;
  color: white;

  a button,
  ${ButtonContent} {
    color: white;
  }

  svg {
    fill: white;
  }
`;
export const TwoViewsContainer = styled.div `
  position: relative;
  height: calc(100vh - 50px);
  overflow: hidden;

  > * {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;
export const SmallImage = styled.img `
  width: 150px;
  height: auto;
  margin-bottom: 40px;
  ${props => props.theme.mixins.mobile('display: none')}
`;
